export enum TenancyAgreementSignedStatuses {
    UNSIGNED = 0,
    ESIGNED = 1,
    MANUALLY_SIGNED = 2,
    ALREADY_SIGNED = 3
}
